import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import { Breadcrumbs, Link, TablePagination, Typography } from "@mui/material";
import RefreshButton from "../../../../../common/components/refresh_button";
import { Header } from "./components/header";
import { useQualidadeAcoesCorretivasViewModel } from "../../viewModels/qualidade_acoes_corretivas_view_model";
import { useMemo } from "react";
import { GenerateQualidadeAcoesCorretivasColumns } from "./columns/qualidade_acoes_corretivas";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { AcoePreventivasLista } from "../../../domain/models/acoes_melhorias_lista";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";

export const Acoes_Corretivas = () => {
  const viewModel = useQualidadeAcoesCorretivasViewModel();
  const QualidadeAcoesCorretivasListalColumns = useMemo(() => {
    return GenerateQualidadeAcoesCorretivasColumns({
      onActionEditar: viewModel.handleNewAcoesCorretivas,
      onActionDeletar: viewModel.handleDeleteAcoesCorretivasModalOpenState,
      onActionExportar: viewModel.handleAcoesCorretivaaExportar,
    });
  }, [viewModel.handleAcoesCorretivaaExportar, viewModel.handleDeleteAcoesCorretivasModalOpenState, viewModel.handleNewAcoesCorretivas]);



  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[230px] ">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onClick={() => viewModel.handleNewAcoesCorretivas("Corretiva", null)}>
                  Nova ação corretiva
                </PrimaryButton>
              </div>
            </div>
          } />
      </PageTopBar>
      <form>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Qualidade
            </Link>
            <Typography className="text-primary-green">
              Ações Corretivas
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Ações Corretivas</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>
          </div>
          <Header
            onClearFilters={viewModel.handleClearFilters}
            handleTipoPesquisa={viewModel.handleTipoPesquisaChange}
            handleStatus={viewModel.handleStatusChange}
            handlePesquisa={viewModel.handlePesquisaChange}
            pesquisa={viewModel.filters.pesquisa}
            tipoPesquisa={viewModel.filters.tipoPesquisa}
            status={viewModel.filters.status}
            centroDeCusto={viewModel.filters.centroDeCusto}
            centroDeCustoLista={viewModel.filters.centroDeCustoLista ?? []}
            handleCentroDeCusto={viewModel.handleCentroDeCustoChange}

          />
          <StyledDataGrid
            tableName="AcoesCorretivas_lista"
            disableColumnMenu={false}
            getRowId={(row: AcoePreventivasLista) => row.IdAcaoQualidade}
            columns={QualidadeAcoesCorretivasListalColumns}
            loading={viewModel.loading}
            rows={viewModel.acoesCorretivasLista}
            rowCount={viewModel.pagination.totalItems}
            sx={{
              '& .status-header': {
                backgroundColor: '#AFDFD5',
                color: '#000'
              }
            }}
            pinnedColumns={{
              right: ['IdAcaoQualidade'],
            }}
            autoHeight={true}
            textSize="medio"
            getRowHeight={() => "auto"}
            pageSizeOptions={[10]}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page,
              pageSize: viewModel.pagination.rowsPerPage,
            }} />

          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
        </div>
      </form>

      <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      />

      {/* Deletar Registro */}
      <DeleteDialog
        open={viewModel.acoesCorretivasDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteAcoesCorretivasModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaAcoesCorretivas} />
    </>
  )
}